import { render } from "./FasciasBenefits.vue?vue&type=template&id=5f258f38"
import script from "./FasciasBenefits.vue?vue&type=script&lang=js"
export * from "./FasciasBenefits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__